import { configureCompat } from 'vue';

configureCompat({
    MODE: 2,
    GLOBAL_SET: false,
    GLOBAL_DELETE: false,
    WATCH_ARRAY: false,
});
